export default __webpack_public_path__ + "static/media/AllProducts.7c61266e.jpg";